export function configuredDirectionByLanguage(type) {
  window.addEventListener('DOMContentLoaded', () => {
    let G_isRtl = document.body?.getAttribute("dir") === "rtl";
    let isRTL = type === "he";
    let basicElement = document.getElementById('root');
    if (basicElement != null) {
      if (isRTL) {
        if (!G_isRtl) {
          basicElement.setAttribute("dir", "rtl")
        }
      } else {
        basicElement.setAttribute("dir", "ltr")
      }
    }
  });
}